export default __webpack_public_path__ + "static/logo-fa753a8b0b529f8e3021067fa6f7fcab.svg";